import axios from "axios";
import { apiRoutesForContext } from "src/routes/apiRoutes/react-api-route-paths";
import { EmailComfirmationURL, ForgotPassword, Login, Register, ResetPassword, User } from "src/sdk";
import { BaseService } from "../services/BaseService";

export interface IAuthService {
    login: (data: Login) => Promise<User>;
    register: (data: Register) => Promise<User>;
}

const tmp = apiRoutesForContext();
export class AuthService extends BaseService implements IAuthService {
    public authRoutes: typeof tmp;

    constructor() {
        super();
        this.authRoutes = apiRoutesForContext();
    }

    login(data: Login): Promise<any> {
        return axios({
            method: "post",
            baseURL: this.routes.server.root(),
            headers: { "Content-Type": "application/json" },
            url: this.routes.auth().login(),
            data: data
        })
    }

    register(data: Register): Promise<any> {
        return axios({
            method: "post",
            baseURL: this.routes.server.root(),
            headers: { "Content-Type": "application/json" },
            url: this.routes.auth().register(),
            data: data
        })
    }
    getEmailComfirmationURL(data: EmailComfirmationURL): Promise<any> {
        return axios({
            method: "get",
            baseURL: this.routes.server.root(),
            headers: { "Content-Type": "application/json" },
            url: this.routes.auth().getEmailComfirmationUrl() + "?userId=" + data.userId + "&code=" + data.code,
        })
    }
    forgotPassword(data: ForgotPassword): Promise<any> {
        return axios({
            method: "post",
            baseURL: this.routes.server.root(),
            headers: { "Content-Type": "application/json" },
            url: this.routes.auth().forgotPassword(),
            data: data
        })
    }

    resetPassword(data: ResetPassword): Promise<any> {
        return axios({
            method: "post",
            baseURL: this.routes.server.root(),
            headers: { "Content-Type": "application/json" },
            url: this.routes.auth().resetPassword(),
            data: data
        })
    }
}
